export default __webpack_public_path__ + "static/jared-f6d7a331191c8fcba44cb9bb0e06e1e3.jpg";